import {
  FETCH_WITHDRAWS,
  FETCH_WITHDRAWS_SUCCESS,
  FETCH_WITHDRAWS_FAILED,
  EDIT_WITHDRAWS
} from "../store/types";
import { cloud_function_server_url } from '../../config';

const END_POINT = `${cloud_function_server_url}/transaction`;

export const fetchWithdraws = () => (dispatch) => (firebase) => {

  const {
    withdrawRef
  } = firebase;

  fetch(`${END_POINT}/fetch-withdraws`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then(async (res) => {
      const response = await res.json();
      if (response?.success) {
        const arr = response.data?.map((item) => {
          item.id = item._id;
          return item;
        })
        dispatch({
          type: FETCH_WITHDRAWS_SUCCESS,
          payload: arr.reverse()
        });
      } else {
        dispatch({
          type: FETCH_WITHDRAWS_FAILED,
          payload: "No WITHDRAWS available."
        });
      }
    }).catch(error => {
      dispatch({
        type: FETCH_WITHDRAWS_FAILED,
        payload: "No WITHDRAWS available."
      });
      console.log("fetchTransactions error", error)
    });

  dispatch({
    type: FETCH_WITHDRAWS,
    payload: null
  });
  // withdrawRef.on("value", snapshot => {
  //   if (snapshot.val()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data).map(i => {
  //       data[i].id = i
  //       return data[i]
  //     });
  //     dispatch({
  //       type: FETCH_WITHDRAWS_SUCCESS,
  //       payload: arr.reverse()
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_WITHDRAWS_FAILED,
  //       payload: "No WITHDRAWS available."
  //     });
  //   }
  // });
};

export const completeWithdraw = (entry) => (dispatch) => (firebase) => {

  const {
    withdrawRef
  } = firebase;

  dispatch({
    type: EDIT_WITHDRAWS,
    payload: entry
  });

  fetch(`${END_POINT}/complete-withdraw`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ id: entry.id })
  })
    .then(async (res) => {
      const response = await res.json();
      if (response.success) {
        fetchWithdraws()(dispatch)(firebase);
      }
      console.log("completeWithdraw res", response)
    }).catch(error => {
      console.log("completeWithdraw error", error)
    });
  // withdrawRef.child(entry.id).update({ ...entry, processed: true, procesDate: new Date().toString() });
}